import 'angular';
import template from './funders_chart.template.html?raw';
/* eslint-disable-next-line max-len */
import '../../../../../lib/assets/javascripts/devex/angular/directives/visualizations/charts/pie-chart.directive';

const moduleDependencies = [
  'directives.visualizations.pieChart',
];

const bindings = {
  searchJs: '<',
  chartData: '<',
  emptyResultsText: '<'
};

const fundersChartController = function() {
  const that = this;
  /**
   * Check if value is present in an array of objects
   *
   * @param {Array} array - array of objects
   * @param {string} key - object key
   * @param {string} value - key value
   *
   * @returns {boolean}
   */
  that.containsKeyValue = (array, key, value) => {
    if (array.length === 0) {
      return false;
    }
    return array.some(element => element[key] === value);
  };

  /**
   * Adds new filter, if unique, to places filter in searchJs
   *
   * @param {string} value - Selected Funder
   *
   * @returns {undefined}
   */
  that.addFunderFilterHandle = (value) => {
    if ( !that.containsKeyValue(that.searchJs.filter.donors.value, 'short_name', value) ) {
      that.searchJs.filter.donors.addValue({short_name: value});
      that.searchJs.notifyParamChange();
    }
  };
};

const controller = [fundersChartController];

const options = {
  templateUrl: template,
  bindings,
  controller,
  controllerAs: 'vm',
};

angular
  .module('fundingSearchApp.components.fundersChart', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('fundersChart', options);
